const initialMyPermissions = {
  myPermissionsData: null,
  myPermissionsMeta: {},
  loadingMyPermissions: false,
  errorsMyPermissions: {},
};

const myPermissionsReducer = (state = initialMyPermissions, action) => {
  switch (action.type) {
    case "GET_MY_PERMISSIONS_PENDING":
      return { ...state, loadingMyPermissions: true };
    case "GET_MY_PERMISSIONS_FULFILLED":
      return {
        ...state,
        loadingMyPermissions: false,
        myPermissionsData: action.payload,
        myPermissionsMeta: action.permissions ?? {},
        errorsMyPermissions: {},
      };
    case "GET_MY_PERMISSIONS_REJECTED":
      return {
        ...state,
        loadingMyPermissions: false,
        errorsMyPermissions: action.payload,
      };
    default:
      return state;
  }
};

export default myPermissionsReducer;
